import { $ABTest, $InstalledRelatedApp, $UserAgent } from '@lemon8/web-app-shared/atom';
import { DeepLinkBuildingProps, buildSchema } from './schema';
import { $SharingEnterTraffic, $SharingCurrentTraffic } from 'shared/atoms';
import { EClickPosition } from 'shared/constant/click-position';
import { ExtractAtomValue } from 'jotai';
import { buildDeepLink } from './deeplink';
import { $UseSchemaDirectCall } from '../libra/schema-call-app';
import { SharingCurrentTrafficUtil, SharingEnterTrafficUtil } from 'shared/utils';

export interface ActiveProps {
  schemaOption: DeepLinkBuildingProps;
  ampExtraOption: {
    clickPosition: EClickPosition;
    clickId?: string;
  };
}

export const active = (props: ActiveProps): void => {
  const { schemaOption, ampExtraOption } = props;
  const store = window.store;
  const href = new URL(location.href);

  const { userAgent } = navigator;

  const { versions } = store.get($ABTest);

  const { isiOS, isMacOS } = store.get($UserAgent);
  const enterTraffic = store.get($SharingEnterTraffic);
  const currentTraffic = store.get($SharingCurrentTraffic);
  const useSchemaDirectCall = store.get($UseSchemaDirectCall);
  const hasApp = !(['pending', null] as ExtractAtomValue<typeof $InstalledRelatedApp>[]).includes(
    store.get($InstalledRelatedApp),
  );

  const fromScene = href.searchParams.get('from_scene');

  const schema = buildSchema({
    itemFrom: enterTraffic.itemFrom,
    ...schemaOption,
  });

  const oneLink = new URL('https://lemon8.onelink.me/FMQw');
  oneLink.searchParams.set('pid', enterTraffic.trafficPid);

  if (
    (userAgent.includes('Instagram') && userAgent.includes('AppleWebKit')) ||
    userAgent.includes('Messenger') ||
    userAgent.match(/FBAN|FBAV/i) ||
    (userAgent.includes('Snapchat') && userAgent.includes('AppleWebKit')) ||
    userAgent.includes('Lark') ||
    userAgent.includes('Line')
  ) {
    oneLink.searchParams.set('af_force_deeplink', 'true');
  }

  oneLink.searchParams.set('af_dp', schema);
  oneLink.searchParams.set('retargeting', 'true');
  oneLink.searchParams.set('ab_version', versions);
  oneLink.searchParams.set(
    'af_web_dp',
    isiOS || isMacOS
      ? 'https://itunes.apple.com/app/apple-store/id1498607143?pt=1613620&ct=interstitialdownload&mt=8'
      : 'https://play.google.com/store/apps/details?id=com.bd.nproject',
  );
  oneLink.searchParams.set(
    'amp_extra',
    JSON.stringify({
      traffic_type: enterTraffic.trafficPid,
      is_from_wap: 1,

      // share_user_id: rootTraffic.sharerUid,
      // share_device_id: rootTraffic.sharerDid,
      // share_time: rootTraffic.shareTime,

      _t: enterTraffic.sharerToken,

      share_platform: enterTraffic.sharePlatform || null,

      // share content extra
      ...SharingEnterTrafficUtil.getShareContentExtra(enterTraffic),

      // enter page extra
      ...SharingCurrentTrafficUtil.getEnterPageExtra(currentTraffic),

      // cta extra
      enter_position: ampExtraOption.clickPosition,
      enter_page_click_id: ampExtraOption.clickId || null,

      // TikTok profile bind
      from_scene: fromScene,
    }),
  );

  if (useSchemaDirectCall && hasApp) {
    const deepLink = buildDeepLink(props);
    location.href = deepLink;
  } else {
    window.open(oneLink.toString());
  }
};
